<template>
    <section class="w-full video-height relative overflow-hidden" v-if="groupRebate != null && !expired">
        <!-- Background Video Section -->
        <section class="framer-15nod7u" data-framer-name="BG Video">
            <div class="framer-udskdh" data-framer-name="Bottom Shadow"></div>
            <div class="ssr-variant">
                <div class="framer-ryrj4a-container" style="opacity: 1; will-change: transform; transform: none">
                    <video loop preload="auto" muted playsinline
                        poster="https://customer-cc44yfs1ng5d1ck2.cloudflarestream.com/047c7a99749389cbed8b9024346bdbf9/thumbnails/thumbnail.jpg"
                        loading="lazy" style="
                    cursor: auto;
                    width: 100%;
                    height: 100%;
                    border-radius: 0px;
                    display: block;
                    object-fit: cover;
                    background-color: rgba(0, 0, 0, 0);
                    object-position: 50% 50%;
                    " autoplay>
                        <source src="https://framerusercontent.com/assets/x63grw3MJJK8pzlD0qnG8C0qVfs.mp4"
                            media="(max-width: 768px)" />
                        <source src="https://framerusercontent.com/assets/x63grw3MJJK8pzlD0qnG8C0qVfs.mp4"
                            media="(min-width: 2560px)" />
                        <source src="https://framerusercontent.com/assets/x63grw3MJJK8pzlD0qnG8C0qVfs.mp4" />
                    </video>
                </div>
            </div>
            <div class="framer-kdzoja" data-framer-name="Blur"></div>
        </section>

        <!-- Main Content Container -->
        <div class="absolute inset-0 flex items-center justify-center z-10">
            <v-container class="w-full mx-auto px-0">
                <v-card elevation="0" dark max-width="1408" color="transparent" class="mx-auto px-4 r-p-x-0">
                    <v-row no-gutters align="center" class="min-h-0">
                        <v-col cols="12" sm="12" md="6" class="flex flex-col justify-center">
                            <!-- Left Side - Main Content -->
                            <div class="text-left my-6 sm:my-8 lg:pr-12">
                                <!-- Badge -->
                                <div
                                    class="inline-flex items-center bg-blue-600 text-white px-3 py-1.5 rounded-full text-base font-medium lexend-deca mb-6">
                                    <span class="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                                    <span class="ml-2 text-blue-200">GROUP BUY DEAL</span>
                                </div>

                                <!-- Main Headline -->
                                <h1 class="text-white banner-h1 poppins leading-tight mb-6">
                                    <span>Buy Bitcoin at Up to</span>
                                    <br />
                                    <span class="text-complementary">{{ groupRebate?.maxRebateRatio * 100 || 0 }}% Off!</span>
                                    <!-- text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 -->
                                </h1>

                                <!-- Description -->
                                <p class="text-gray-300 banner-h6 leading-relaxed max-w-xl lexend-deca">
                                    The more people join, the bigger the discount for everyone.
                                    Join now and boost your savings!
                                </p>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" class="flex justify-end md:justify-end items-center r-m-t-6">

                            <!-- Right Side - Timer -->
                            <div>
                                <div class="flex justify-between mb-6">
                                    <div>
                                        <div class="text-white banner-h3 poppins">
                                            {{ groupRebate?.buyerSize }}
                                        </div>
                                        <div class="text-white/70 banner-h6 lexend-deca">
                                            bought
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-white banner-h3 poppins">
                                            {{ currentRebateRate }}%
                                        </div>
                                        <div class="text-white/70 banner-h6 lexend-deca">
                                            current discount/rebate rate
                                        </div>
                                    </div>
                                </div>
                                <div class="timer-card w-full text-center">
                                    <div class="timer-bg-overlay"></div>
                                    <div class="timer-glow"></div>
                                    <div class="relative z-10">
                                        <div class="text-white mb-4">
                                            <p class="banner-h6 mb-2 sm:mb-3 opacity-90 lexend-deca">
                                                {{ !expired ? "Offer expires in" : "Deal expired!" }}
                                            </p>
                                            <h1 class="banner-h1 poppins text-white tracking-wider mb-4">
                                                {{ formatTime(timeLeft.hours) }}:{{
                                                    formatTime(timeLeft.minutes)
                                                }}:{{ formatTime(timeLeft.seconds) }}
                                            </h1>
                                        </div>
                                        <div class="text-gray-400 banner-h6 opacity-90 mb-4 lexend-deca">
                                            1 {{ groupRebate?.wrappedCurrency || "unToken" }}, from 2
                                            to 100 buyers
                                        </div>
                                        <Button :to="`/uncrypto/${groupRebate?.wrappedCurrency?.toLowerCase()}/${groupRebate?.cryptoId
                                            }`" :disabled="expired" variant="primary" rounded="lg" color="black03"
                                            width="260" aria-label="Earn Rewards">Join Group Buy Now</Button>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-container>
        </div>
    </section>
</template>

<script>
import CryptoGroupRebateAPI from "@/api/crypto-group-rebate";
import Decimal from "decimal.js";
export default {
    data() {
        return {
            timeLeft: {
                hours: 0,
                minutes: 0,
                seconds: 0,
            },
            expired: true,
            timer: null,
            groupRebate: null,
            visibilityChangeHandler: null,
        };
    },
    computed: {
        // 当前返利比例
        currentRebateRate() {
            return new Decimal(this.groupRebate?.currentRebateRatio).mul(new Decimal(100)).toNumber();
        },
    },
    mounted() {
        // 获取最新一个加密货币团购返利摘要
        this.getLatestCryptoGroupRebateSummary();
    },
    methods: {
        // 初始化视频相关功能
        initVideoFeatures() {
            // 使用 nextTick 确保 DOM 已更新
            this.$nextTick(() => {
                const video = document.querySelector("video");

                // 确保视频元素存在
                if (!video) {
                    console.warn("Video element not found");
                    return;
                }

                // Optimize video for mobile
                if (window.innerWidth <= 768) {
                    video.setAttribute("src", "low-res-video.mp4");
                }

                // 创建 visibility change 处理函数
                this.visibilityChangeHandler = () => {
                    // 再次检查视频元素是否存在
                    const currentVideo = document.querySelector("video");
                    if (currentVideo) {
                        if (document.hidden) {
                            currentVideo.pause();
                        } else {
                            // 使用 Promise 处理 play() 方法
                            currentVideo.play().catch(error => {
                                console.warn("Video play failed:", error);
                            });
                        }
                    }
                };

                // 添加 visibility change 事件监听
                document.addEventListener("visibilitychange", this.visibilityChangeHandler);
            });
        },

        // 格式化时间
        formatTime(time) {
            return time.toString().padStart(2, "0");
        },

        // 开始倒计时
        startCountdown() {
            this.expired = false;

            // 初始化视频功能（当数据加载完成且组件显示时）
            this.initVideoFeatures();

            this.timer = setInterval(() => {
                // 计算剩余时间
                this.calcTimeRemaining(this.groupRebate.endTimestamp);
            }, 1000);
        },

        // 时间过期
        onTimeExpired() {
            this.expired = true;
        },

        // 查询最新一个加密货币团购返利摘要
        async getLatestCryptoGroupRebateSummary() {
            try {
                let res = await CryptoGroupRebateAPI.getLatestCryptoGroupRebateSummary();
                const data = res.data;
                if (data.success) {
                    this.groupRebate = data.data;
                    // 计算剩余时间
                    this.calcTimeRemaining(this.groupRebate.endTimestamp);
                    // 开始倒计时
                    this.startCountdown();
                }
            } catch (error) {
                console.error("Failed to fetch group rebate data:", error);
            }
        },

        // 计算剩余时间
        calcTimeRemaining(endTimestamp) {
            // 获取当前时间戳（毫秒）
            const now = Date.now();
            // 计算剩余时间（毫秒）
            const remaining = endTimestamp - now;

            // 如果目标时间已过
            if (remaining <= 0) {
                this.timeLeft = { hours: 0, minutes: 0, seconds: 0 };
                this.onTimeExpired();
                if (this.timer) {
                    clearInterval(this.timer);
                }
                return;
            }

            // 计算总秒数
            const totalSeconds = Math.floor(remaining / 1000);
            // 计算小时、分钟、秒
            const seconds = Math.floor(totalSeconds % 60);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const hours = Math.floor(totalSeconds / 3600);

            this.timeLeft = { hours: hours, minutes: minutes, seconds: seconds };
        },
    },

    beforeUnmount() {
        // 清理定时器
        if (this.timer) {
            clearInterval(this.timer);
        }

        // 清理事件监听器
        if (this.visibilityChangeHandler) {
            document.removeEventListener("visibilitychange", this.visibilityChangeHandler);
        }
    },
};
</script>

<style scoped>
/* 视频容器高度 */
.video-height {
    height: 45rem;
}

@media (min-width: 1024px) {
    .video-height {
        height: 30rem;
    }
}

@media (min-width: 1920px) {
    .video-height {
        height: 35rem;
    }
}

/* 背景视频样式 */
.framer-15nod7u {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.framer-udskdh {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
}

.framer-ryrj4a-container {
    width: 100%;
    height: 100%;
}

.framer-kdzoja {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    background: rgba(0, 0, 0, 0.1);
}

/* 计时器卡片样式 */
.timer-card {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 1.5rem;
    padding: 1rem 1.5rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    position: relative;
    overflow: hidden;
    width: 420px;
}

.timer-bg-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg,
            rgba(59, 130, 246, 0.05),
            rgba(168, 85, 247, 0.05));
    border-radius: 1.5rem;
}

.timer-glow {
    position: absolute;
    top: 0;
    right: 0;
    width: 8rem;
    height: 8rem;
    background: linear-gradient(225deg, rgba(59, 130, 246, 0.1), transparent);
    border-radius: 50%;
    filter: blur(1.5rem);
}

/* 渐变文字 */
.bg-clip-text {
    background-clip: text;
    -webkit-background-clip: text;
}

.text-transparent {
    color: transparent;
}

.banner-h1 {
    font-size: 3.5rem;
    line-height: 1.25;
}

.banner-h3 {
    font-size: 3rem;
    line-height: 1.5;
}

.banner-h6 {
    font-size: 1rem;
    line-height: 1.5rem;
}

/* 移动端优化 */
@media (max-width: 768px) {
    .flex-col {
        align-items: center;
        text-align: center;
    }

    .timer-card {
        max-width: 320px;
        margin: 0 auto;
    }

    .framer-ryrj4a-container video {
        object-fit: cover;
        object-position: center;
        height: 100vh;
    }

    .framer-kdzoja {
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
    }

    .framer-15nod7u {
        height: 100vh;
    }

    video {
        min-height: 100vh;
    }

    .banner-h1 {
        font-size: 3rem;
        line-height: 1;
    }

    .banner-h3 {
        font-size: 1.5rem;
        line-height: 2rem;
    }

    .banner-h6 {
        font-size: 0.875rem;
        line-height: 0.875rem;
    }
}

@media (max-width: 640px) {
    .timer-card {
        max-width: 300px;
        padding: 1rem;
    }

    button {
        min-height: 48px;
        padding: 0.75rem 1.5rem;
    }

    button:active {
        transform: scale(0.95);
        opacity: 0.9;
    }

    .banner-h1 {
        font-size: 3rem;
        line-height: 1;
    }

    .banner-h3 {
        font-size: 1.5rem;
        line-height: 2rem;
    }

    .banner-h6 {
        font-size: 0.875rem;
        line-height: 0.875rem;
    }
}

/* 超宽屏优化 */
@media (min-width: 2560px) {
    .max-w-7xl {
        max-width: 1400px;
    }

    .timer-card {
        max-width: 400px;
    }
}
</style>
